module.exports = __webpack_public_path__ + "img/appstore-tra-white.aa25c439.png";